$(function () {
  $(document).on('change', '#split-methods-select', function () {
    let selectedMethod = $(this).val();
    const paymentMethod = selectedMethod;
    const paymentSplitInput = $('#payment-split-input');

    if (paymentMethod != 'payment_giftcard') {
      paymentSplitInput
        .removeAttr('data-remaining-credit-limit')
        .removeData('remaining-credit-limit');
    }

    if (paymentMethod == 'payment_giftcard') {
      $('#split-method-giftcard-validator-container').removeClass('d-none');
      $('#payment-split-button').attr('disabled', true);
      $('#payment-split-input').attr('disabled', true);
    } else if (OnDevice.isPaymentMethod(paymentMethod)) {
      $('#payment-split-button').attr(
        'data-terminal-id',
        $('#split-methods-select option:selected').attr('data-terminal-id')
      );
      $('#split-method-giftcard-validator-container').addClass('d-none');
      if (OnDevice.active()) {
        // on the terminal itself: usable once the payment app has its session open
        $('#payment-split-button').attr('disabled', !OnDevice.sessionStarted());
      } else {
        $('#payment-split-button').attr('disabled', false);
      }
      $('#payment-split-input').attr('disabled', false);
    } else if (paymentMethod == 'payment_terminal') {
      $('#payment-split-button').attr(
        'data-terminal-id',
        $('#split-methods-select option:selected').attr('data-terminal-id')
      );
      $('#split-method-giftcard-validator-container').addClass('d-none');
      $('#payment-split-button').attr('disabled', false);
      $('#payment-split-input').attr('disabled', false);
    } else {
      $('#split-method-giftcard-validator-container').addClass('d-none');
      $('#payment-split-button').attr('disabled', false);
      $('#payment-split-input').attr('disabled', false);
    }

    $('#payment-split-input').attr('data-payment-method', paymentMethod);
    $('#payment-split-button').attr('data-payment-method', paymentMethod);
  });
});
